import React, { useCallback, useMemo } from "react"
import { useGeneral } from "../../../context/general"
import MultiselectTickerDropdown from "./MultiselectTickerDropdown"
import TextFieldPaper from "../TextFieldPaper"
import { Divider, Autocomplete, CircularProgress, InputAdornment, Paper, ListSubheader } from '@mui/material'
import { Search, Done } from '@mui/icons-material'
import VirtualListbox from '../VirtualListbox'
import styles from './TickerDropdown.module.scss'

export default function TickerDropdown({sortedTickers, textFieldProps = [], loading, renderOption, handleChange, disableCloseOnSelect=false, value=[], multiple=false, open=false, elevation=7, onClose, divider = false, shouldShowChips, limit, ...props}) {
    const { tickers } = useGeneral()

    const tickersList = useMemo(() => sortedTickers ?? tickers ,[tickers, sortedTickers])

    const paper = useCallback((props) => <Paper elevation={elevation}>{props.children}</Paper>,[elevation])

    const icon = (
        <InputAdornment key='icon' position="start" classes={{root: styles['svg']}}>
            { !loading ? <Search/> : <CircularProgress size="1.5rem" color="inherit"/> }
        </InputAdornment>
    )

    const defaultRenderOption = (params, { name, value }, {selected}) => (
        <li {...params}>
            <div className={styles['option']}>
                <div>
                    <div>{name}</div>
                    <div>{value}</div>
                </div>
                {selected && <Done/>}
            </div>
        </li>

    )

    const handleCloseOption = (e) => e.key === "Escape" && onClose()

    const renderInput = (params) => {
        const modifiedParams = {
            ...params,
            InputProps: {
                ...params.InputProps,
                startAdornment: shouldShowChips ? [icon, ...(params?.InputProps?.startAdornment ?? []) ] : icon
            },
            autoFocus: open,
            ...textFieldProps,
        }

        return (
            <>
                <TextFieldPaper
                    {...modifiedParams}
                    placeholder="Search for a ticker or company name"
                    variant="outlined"
                />
                {divider && <Divider/>}
            </>
        )
    }

    const renderGroup = (params) => ([
        <ListSubheader key={params.key} component="div">{params.group}</ListSubheader>,
        params.children,
    ])

    const onChange = (e, newValue) => {
        if(!Array.isArray(newValue) || !limit || newValue.length <= limit ){
            handleChange(newValue)
        }
    }

    const getOptionLabel = (option) => `${option?.value} ${option?.name}` 

    const AutocomleteComponent = (
        <Autocomplete
            key='tickers-autocomlete'
            forcePopupIcon
            disableListWrap
            fullWidth
            loading={!tickersList}
            options={tickersList ?? []}
            getOptionLabel={getOptionLabel}
            groupBy={(option) => option.category}
            onChange={onChange}
            renderInput={renderInput}
            renderOption={renderOption ?? defaultRenderOption}
            renderGroup={renderGroup}
            ListboxComponent={VirtualListbox}
            autoHighlight
            disableCloseOnSelect={disableCloseOnSelect}
            PaperComponent={paper}
            {...(open && {open, onClose:handleCloseOption})}
            {...props}
        />
    )

    return (
        multiple 
            ? <MultiselectTickerDropdown value={value} multiple tickers={tickersList}>
                    {AutocomleteComponent}
              </MultiselectTickerDropdown> 
            : AutocomleteComponent
    )
}

